export const denmarkAreas = ['Hovedstaden', 'Midtjylland', 'Nordjylland', 'Sjælland', 'Syddanmark'] as const;
export const denmarkAreasMap = {
  Hovedstaden: { id: '06181', lat: 55.7664, long: 12.5263 },
  Midtjylland: { id: '06060', lat: 56.2935, long: 9.1138 },
  Nordjylland: { id: '06030', lat: 57.0963, long: 9.8505 },
  Sjælland: { id: '06154', lat: 55.2075, long: 11.8605 },
  Syddanmark: { id: '06118', lat: 54.9616, long: 9.793 },
};

export type DenmarkArea = (typeof denmarkAreas)[number];
